import * as Yup from 'yup';
import { phoneNumberFormatter } from './phoneNumber.validation';

const contactSupportBaseFields = {
  summary: Yup.string()
    .label('Subject')
    .max(40, 'Subject is max 40 characters length')
    .required(),
  description: Yup.string()
    .label('Description')
    .max(250, 'Description is max 250 characters length')
    .required(),
  category: Yup.string().label('Category').required(),
  name: Yup.string().label('Name').required(),
  email: Yup.string().label('Email').email('Invalid email address').required()
};

/**
 * Phone field for contact/support forms.
 *
 * When the user already has a profile phone (read-only), skip format validation —
 * AD-sourced values are accepted as-is (ST-1842).
 */
export const buildContactSupportPhoneField = (shouldValidate: boolean) =>
  shouldValidate
    ? Yup.string()
        .label('Your phone number')
        .max(16, 'Maximum 16 Characters.')
        .required()
        .test(
          'validate-cpnumber',
          'Please enter a valid phone number',
          (value): any => {
            return phoneNumberFormatter({ phoneNumber: value || '' }).isValid();
          }
        )
    : Yup.string().notRequired();

/**
 * @param hasProfilePhone - true when logged-in user already has phoneNumber on profile
 */
export const getContactSupportSchema = (hasProfilePhone: boolean) =>
  Yup.object().shape({
    ...contactSupportBaseFields,
    phoneNumber: buildContactSupportPhoneField(!hasProfilePhone)
  });

/** @deprecated Use getContactSupportSchema(hasProfilePhone) */
export const ContactSupportSchema = getContactSupportSchema(false);
